export default function Skeleton({ className = '', style }) {
  return (
    <div
      className={`animate-pulse rounded-xl ${className}`}
      style={{
        background: 'var(--dash-surface-hover)',
        ...style,
      }}
    />
  )
}
